<template>
  <v-card class="pt-16">
    <v-card-text>
      <v-container fluid>
        <h2 class="text-center">{{ $t('flota') }} </h2>
        <p class="text-justify text-center">{{ $t('flota_descripcion') }}</p>
      </v-container>
      <v-container fluid>
        <v-row dense>
          <v-col v-for="(car, index) in vehiculosClases" :key="index" cols="12"  sm="6"  md="3" xl="2" class="d-flex justify-center">
            <MicroCard
              :car="car"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MicroCard from "../components/MicroCard.vue";

export default {
  components: {
    MicroCard
  },
  name: 'flota',
  data: () => ({
    titulo:'Flota',
    descripcion:'Ya sea por viaje de negocios o de placer, puede elegir un vehículo de nuestra flota según su necesidad. Desde autos compactos para 20 pasajeros hasta súper familiares para 80 personas, estamos seguros que puede encontrar lo que necesita.',
  }),
  created() {
    if (this.autos.length === 0) {
      this.getAutos()
    }
  },
  computed:{
    ...mapState(['autos','modelos', 'vehiculosClases'])
  },
  methods:{
    ...mapActions(['getAutos'])
  }
}
</script>